import FetchFactory from '../factory'

interface IUpdateProfile {
  body: {
    first_name: string
    last_name: string
    gender: string
    date_of_birth: string
    nationality_id: number
    province_id: number
    job_type_id: number
    address: string
    email: string
    phone_number: string
    short_description: string
    intro_video_url: string
    category_ids: Array<number>
    portfolio_url: string
    work_location_wish: any
  }
}

interface IUpdateJobSeekerSkills {
  body: {
    category?: string
    skills: Array<Object>
  }
}

interface IUpdateJobSeekerLanguages {
  body: {
    languages: Array<Object>
  }
}

interface IUpdateJobSeekerExperiences {
  body: {
    experiences: Array<Object>
  }
}

interface IUpdateJobSeekerEducations {
  body: {
    educations: Array<Object>
  }
}

interface IUpdateFuturePlans {
  body: {}
}

class ProfileModule extends FetchFactory<any> {
    async getJobSeekerProfile() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile', {
                method: 'GET',
      })
        })
    }

    async getJobSeekerSkills() {
        return await useAsyncData('job-seeker-skills', () => {
            return super.call('/api/job-seeker/profile/skills', {
                method: 'GET',
      })
        })
    }

    async getJobSeekerComputerSkills() {
        return await useAsyncData('job-seeker-computer-skills', () => {
            return super.call('/api/job-seeker/profile/skills', {
                method: 'GET',
                query: { category: 'pc' },
      })
        })
    }

    async updateJobSeekerSkills(payload: IUpdateJobSeekerSkills) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/skills', {
                method: 'POST',
                body
            })
        })
    }

    async getJobSeekerLanguages() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/languages', {
                method: 'GET',
      })
        })
    }

    async updateJobSeekerLanguages(payload: IUpdateJobSeekerLanguages) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/languages', {
                method: 'POST',
                body
            })
        })
    }

    async getJobSeekerAdditionalDocuments() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/additional-documents', {
                method: 'GET',
      })
        })
    }

    async getJobSeekerExperiences() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/experiences', {
                method: 'GET',
      })
        })
    }

    async updateJobSeekerExperiences(payload: IUpdateJobSeekerExperiences) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/experiences', {
                method: 'POST',
                body
            })
        })
    }

    async getJobSeekerEducations() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/educations', {
                method: 'GET',
      })
        })
    }

    async updateJobSeekerEducations(payload: IUpdateJobSeekerEducations) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/educations', {
                method: 'POST',
                body
            })
        })
    }

    async getJobSeekerResume() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/resume', {
                method: 'GET',
      })
        })
    }

    async updateJobSeekerProfile(payload: IUpdateProfile) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile', {
                method: 'POST',
                body
            })
        })
    }

    async getAdditionalInfo() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/additional-info', {
                method: 'GET',
      })
        })
    }

    async getMyJob() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/my-job/saved', {
                method: 'GET',
      })
        })
    }

    async getProfileGenerate() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/generate', {
                method: 'GET',
      })
        })
    }

    async getProfileFuturePlans() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/future-plans', {
                method: 'GET',
      })
        })
    }

    async updatetProfileFuturePlans(payload: IUpdateFuturePlans) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/future-plans', {
                method: 'POST',
                body
            })
        })
    }

    async updatetProfileFuturePlansImportantThings(payload: any) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/future-plans/important-things', {
                method: 'PUT',
                body
            })
        })
    }

    async updatetProfileFuturePlansSectionOne(payload: any) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/future-plans/section-one', {
                method: 'POST',
                body
            })
        })
    }

    async updatetProfileFuturePlansSectionTwo(payload: any) {
        const { body } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/profile/future-plans/section-two', {
                method: 'POST',
                body
            })
        })
    }

    async getProfileCompleteInfo() {
        return await useAsyncData(() => {
            return super.call('/api/auth/profile/check', {
                method: 'GET',
      })
        })
    }

    // ini digunakan untuk submit complete profile dan reapply, klo kena masalah mending pisah untuk submit complete profilenya
    async reapplyProfile() {
        return await useAsyncData(() => {
            return super.call('/api/auth/profile/check', {
                method: 'GET',
                query: { profile_status: 'submitted', reapply: true },
      })
        })
    }
}

export default ProfileModule
